import React, { useEffect, useState } from 'react';
import TermsModal from '../common/modal/TermsAndConditionsModal';
import DashboardService from '../../services/dashboard.service';
import { userStore } from 'store/UserStore';
import DashboardHttp from 'pages/profile/services/profile.service';

type Props = {
  children: React.ReactNode;
};

const TermsGuard = ({ children }: Props) => {
  const customer = userStore((state: any) => state.customer);
  const [loading, setLoading] = useState(false);

  const termsNotAccepted = customer?.termsAndCondition === false;

  useEffect(() => {
    if (termsNotAccepted) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [termsNotAccepted]);

const handleAccept = async () => {
  if (!customer?.customerId) return;

  try {
    setLoading(true);

    await DashboardService.customerConsent({
      terms_and_condition: true,
    });

    userStore.setState({
      customer: {
        ...customer,
        termsAndCondition: true,
      },
    });

  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  if (!customer) return null;

  return (
    <>
      <div className={termsNotAccepted ? "app-locked" : ""}>
        {children}
      </div>

      {termsNotAccepted && (
        <TermsModal
          show={true}
          onAccept={handleAccept}
          loading={loading}
        />
      )}
    </>
  );
};

export default TermsGuard;
